import { render, staticRenderFns } from "./PriceBreakdown.vue?vue&type=template&id=fb574a68&scoped=true&"
import script from "./PriceBreakdown.vue?vue&type=script&lang=js&"
export * from "./PriceBreakdown.vue?vue&type=script&lang=js&"
import style0 from "./PriceBreakdown.vue?vue&type=style&index=0&id=fb574a68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb574a68",
  null
  
)

export default component.exports